import { useDisclosure } from '@mantine/hooks';

export interface IUseDonationFormModalsReturn {
  modalHandlers: {
    openRenameModal: () => void;
    closeRenameModal: () => void;
    openDeleteModal: () => void;
    closeDeleteModal: () => void;
  };
  modalStates: {
    isRenameModalOpen: boolean;
    isDeleteModalOpen: boolean;
  };
}

/**
 * Centralizes state and handlers for donation form contextual action modals (rename, delete).
 * Duplicate is a direct action with no modal, so it is not tracked here.
 */
function useDonationFormModals(): IUseDonationFormModalsReturn {
  const [isRenameModalOpen, { open: openRenameModal, close: closeRenameModal }] =
    useDisclosure(false);
  const [isDeleteModalOpen, { open: openDeleteModal, close: closeDeleteModal }] =
    useDisclosure(false);

  return {
    modalHandlers: {
      openRenameModal,
      closeRenameModal,
      openDeleteModal,
      closeDeleteModal,
    },
    modalStates: {
      isRenameModalOpen,
      isDeleteModalOpen,
    },
  };
}

export default useDonationFormModals;
